const BaseComponent = require('base/base-component');
const Server = require('helper/server');
const Query = require('helper/query');

const redBlackDetailTpl = Handlebars.templates['templates/rights-red-black-detail'];

module.exports = class DetailPage extends BaseComponent {
  constructor () {
    super({
      events: {
        // 'click .js-print': 'print',
        'click .show-detail': 'expandDetail'
      }
    });
    this.query = new Query();
    // this.initQRCode();
    this.getData();
  }

  initQRCode () {
    const type = document.createElement('canvas').getContext ? 'canvas' : 'table';
    const appUrl = window.location.origin+"/app/detail/index.html?id="+this.query.params.id;
    console.log('appUrl', appUrl);
    this.$el.find('.qr-show .qr-code').qrcode({
      render: `${type}`,
      width: 100,
      height: 100,
      text: appUrl,
    });
  }

  getData () {
    Server.getRedBlackDetail({
      id: this.query.params.id
    }).then((res) => {
      this.articleDetail = res;
      this.buildTemplate();
    });
    // this.articleDetail = {
    //   title: '2018年2月红黑榜',
    //   itemList: [
    //     {
    //       name: '很靠谱有限公司',
    //       type: 1,
    //       url: 'https://www.baidu.com',
    //       reason: '服务态度优秀，克服各种困难按照合同发货，多个采购单位对其进行表扬和感谢。'
    //     },
    //     {
    //       name: '很靠谱有限公司2',
    //       type: 1,
    //       reason: '22服务态度优秀，克服各种困难按照合同发货，多个采购单位对其进行表扬和感谢。'
    //     },
    //     {
    //       name: '不靠谱有限公司',
    //       type: 2,
    //       reason: '服务态度恶劣，多次不按照合同发货，多个采购单位对其进行投诉。在投诉后依然推脱。'
    //     },
    //     {
    //       name: '不靠谱有限公司2',
    //       type: 2,
    //       reason: '22服务态度恶劣，多次不按照合同发货，多个采购单位对其进行投诉。在投诉后依然推脱。'
    //     }
    //   ]
    // };
    // this.buildTemplate();
  }

  /**
   * 构建文章内容的html，用于填充到iframe中
   */
  buildTemplate () {
    const { itemList, title } = this.articleDetail;
    document.title=title;
    $('#breadTitle').text(title);
    $('#breadTitle').attr('title', title);

    const redList = [];
    const blackList = [];
    itemList.forEach((item) => {
      if (item.type === 1) {
        redList.push(item);
      } else if (item.type === 2) {
        blackList.push(item);
      }
    });
    redList.forEach((item, index) => { item.index = ++index; });
    blackList.forEach((item, index) => { item.index = ++index; });
    let content = redBlackDetailTpl({
      title,
      redList,
      blackList
    });
    this.$el.find('#redBlackContent').html(content);
    this.initQRCode();
    // let posY = this.$el.find('.rich-content').offset().top;
    // this.$el.find('.tools').css('top', posY - 20);
  }

  expandDetail (e) {
    let $this = $(e.target).parents('.rankint-item');
    $this.siblings()
      .each((index, item) => {
        $(item).removeClass('activated');
      });
    $this.addClass('activated');
  }
};
